import { Stack, Typography } from '@mui/material'
import { unifiedColors } from 'styles/colors'

interface NavigationItemProps {
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  text: string | null
  value?: string
  onClick?: () => void
}

export const NavigationItem = ({
  leftIcon,
  rightIcon,
  text,
  value,
  onClick
}: NavigationItemProps) => {
  return (
    <Stack
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      p={1.5}
      onClick={onClick}
      flexDirection="row"
    >
      <Stack gap={1.5} flexDirection="row" alignItems="center">
        {leftIcon && leftIcon}
        <Typography variant="body2" fontWeight={500}>
          {text}
        </Typography>
      </Stack>
      {value && (
        <Stack
          px={1.5}
          py={0.25}
          bgcolor={unifiedColors.surface.pink}
          borderRadius={1.25}
          justifyContent="center"
        >
          <Typography variant="bodySBold">{value}</Typography>
        </Stack>
      )}
      {rightIcon && rightIcon}
    </Stack>
  )
}
